export default "__VITE_ASSET__D0SE0kmg__"